"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _theme = _interopRequireDefault(require("../../../theme/theme.styles"));

var _FloatingActiveButton = require("./FloatingActiveButton.styles");

var _Icon = require("../../atoms/Icon");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// Accesibility guide: https://inclusive-components.design/tooltips-toggletips/
var FloatingActiveButton = function FloatingActiveButton(_ref) {
  var _ref$text = _ref.text,
      text = _ref$text === void 0 ? 'Comenzar registro' : _ref$text,
      action = _ref.action;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_theme["default"], null), /*#__PURE__*/_react["default"].createElement(_FloatingActiveButton.Occ_FloatingActiveButton_Container, {
    onClick: action
  }, /*#__PURE__*/_react["default"].createElement(_FloatingActiveButton.Occ_FloatingActiveButton_Button, {
    "aria-labelledby": "FloatingActiveButton-label"
  }, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    name: "plus",
    color: "white",
    size: "xl",
    isInline: true
  })), /*#__PURE__*/_react["default"].createElement(_FloatingActiveButton.Occ_FloatingActiveButton_ToolTip, {
    role: "tooltip",
    id: "FloatingActiveButton-label"
  }, text)));
};

var _default = FloatingActiveButton;
exports["default"] = _default;